export const OTP_ERROR = {
  ACCOUNT_2FA_LOCKED: 1007,
  OTP_MISMATCH: 1009,
  ACCOUNT_LOGIN_LOCKED: 1014,
};

export const OTP_MAX_LENGTH = 6;
